import HttpProvider from "@/providers/HttpProvider"
import { AxiosResponse } from "axios"
import { OldFilterDTO } from "../application/OldFilterDTO"
import { SortDTO } from "../application/SortDTO"
import { UrlHelper } from "../application/UrlHelper"
import ProdutoGenericoDTO from "./ProdutoGenericoDTO"

class ProdutoGenericoAPI {

    private httpProvider: HttpProvider;

    constructor() {
        this.httpProvider = new HttpProvider()
    }

    public buscarProdutos(skip = 0, take = 100, sort: SortDTO, filters: OldFilterDTO): Promise<AxiosResponse<Array<ProdutoGenericoDTO>>> {
        const encodedFilter = UrlHelper.buildFilterWithSortAndSkipTake(skip, take, sort, filters)
        return this.httpProvider.axiosInstanceBase.get(`/produto-generico/v2?${encodedFilter}`)
    }

}


export default ProdutoGenericoAPI
